export const fixedHeight = ($window: ng.IWindowService, $timeout: ng.ITimeoutService, screenSize: any) => {
    'ngInject';
    return {
        restrict: 'AEC',
        scope: {
            resize: '@',
        },
        link: function (scope, element, $attrs) {
            function setheight() {
                var offset = $(element).offset();
                // console.log(offset)
                if (offset.top > 0) {
                    var offsetmain = $("#mainview").offset();
                    var offsettop = (offset.top - offsetmain.top)
                    var docHeight = $(window).height();
                    var height = docHeight - offsettop - 95;
                    $(element).height(height);
                }

            }
            if (!screenSize.is('xs, sm')) {
                $timeout(() => {
                    setheight();
                });
                $window.onresize = (event) => {
                    setheight();
                }
                $attrs.$observe('resize', function (resize) {
                    $timeout(() => {
                        setheight();
                    });
                });
            }
        }
    };
};


// WEBPACK FOOTER //
// ./src/app/directive/fixedHeight.ts